import { render } from "./PromotedAds.vue?vue&type=template&id=12de2202&scoped=true"
const script = {}

import "./PromotedAds.vue?vue&type=style&index=0&id=12de2202&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12de2202"]])

export default __exports__